import { t } from '@lingui/core/macro';
import { Trans } from '@lingui/react/macro';
import { LoadingButton } from '@mui/lab';
import { Box, Button, Link, Typography, useTheme } from '@mui/material';
import { queryClient, useCreateMutation } from 'api';
import { Checkbox } from 'components/Checkbox';
import { BasicModal } from 'components/modals/BasicModal';
import { useIsAdminImpersonating } from 'hooks/slices/useCurrentUser';
import LogoOnlyLayout from 'layouts/LogoOnlyLayout';
import { useState } from 'react';
import { toast } from 'react-toastify';
import { useAuthStore } from 'stores/authStore';
import { PRIVACY_POLICY_URL, TERMS_AND_CONDITIONS_URL } from 'utils/linkUtils';

export const AcceptCguPage = () => {
  const [isCguAccepted, setIsCguAccepted] = useState(false);
  const theme = useTheme();
  const signOut = useAuthStore((state) => state.signOut);
  const isAdminImpersonating = useIsAdminImpersonating();

  const acceptCguMutation = useCreateMutation('user/_accept_cgu');

  const acceptCgu = () => {
    if (isAdminImpersonating) {
      toast.error(
        t`Vous ne pouvez pas effectuer cette action en tant qu’admin Faks impersonnifié.`
      );
    } else {
      acceptCguMutation
        .mutateAsync({})
        .then(() => queryClient.invalidateQueries({ queryKey: ['user/_current'] }));
    }
  };

  return (
    <LogoOnlyLayout>
      <BasicModal open title={t`Conditions Générales d’Utilisation`}>
        <Box>
          <Checkbox
            checked={isCguAccepted}
            onChange={(_, checked) => setIsCguAccepted(checked)}
            label={
              <Typography>
                <Trans>
                  En cochant cette case, j’accepte les{' '}
                  <Link href={TERMS_AND_CONDITIONS_URL} target="_blank">
                    Conditions Générales d’Utilisation
                  </Link>{' '}
                  de FAKS et je reconnais que mes données personnelles seront traitées conformément
                  à la{' '}
                  <Link href={PRIVACY_POLICY_URL} target="_blank">
                    Politique de Confidentialité
                  </Link>{' '}
                  de FAKS.
                </Trans>
              </Typography>
            }
          />
          <Box display="flex" justifyContent="flex-end" mt={2}>
            <Button
              onClick={() => signOut()}
              variant="text"
              sx={{ color: theme.palette.grey[500], mr: 2 }}
            >
              {t`Se déconnecter`}
            </Button>
            <LoadingButton
              variant="contained"
              onClick={acceptCgu}
              loading={acceptCguMutation.isPending}
              disabled={!isCguAccepted}
            >
              {t`Accepter`}
            </LoadingButton>
          </Box>
        </Box>
      </BasicModal>
    </LogoOnlyLayout>
  );
};
